//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CandidateTypeValues } from './enums/candidate-type-values.enum';
import { FileBackupStatuses } from './enums/file-backup-statuses.enum';
import { LineOfBusinessEnum } from './enums/line-of-business-enum.enum';
import { LookupPendingUploadStatus } from './enums/lookup-pending-upload-status.enum';
import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { AssignDocumentToContractRequest } from './models/assign-document-to-contract-request.model';
import { AssignDocumentToContractResponseDto } from './models/assign-document-to-contract-response-dto.model';
import { CandidateDocumentInfoResponse } from './models/candidate-document-info-response.model';
import { CandidateDocumentNoteDto } from './models/candidate-document-note-dto.model';
import { CandidateDocumentUpdateRequest } from './models/candidate-document-update-request.model';
import { CandidateDocumentViewerDto } from './models/candidate-document-viewer-dto.model';
import { ComplianceCandidateDocumentDetailDto } from './models/compliance-candidate-document-detail-dto.model';
import { ComplianceCandidateDocumentNoteDto } from './models/compliance-candidate-document-note-dto.model';
import { ComplianceDocumentUploadDto } from './models/compliance-document-upload-dto.model';
import { ContractHistoryDto } from './models/contract-history-dto.model';
import { DocumentUploadToolDetailDto } from './models/document-upload-tool-detail-dto.model';
import { FacilityRequirementDto } from './models/facility-requirement-dto.model';
import { FillPostionSignedContractDto } from './models/fill-postion-signed-contract-dto.model';
import { NoteForCandidateDocumentDto } from './models/note-for-candidate-document-dto.model';
import { PagingTokenOfPostedDocGroupDto } from './models/paging-token-of-posted-doc-group-dto.model';
import { PagingTokenOfSearchCandidateDto } from './models/paging-token-of-search-candidate-dto.model';
import { PersonNameDto } from './models/person-name-dto.model';
import { PostedDocsPermissionDto } from './models/posted-docs-permission-dto.model';
import { RejectDocumentFromDocViewerDto } from './models/reject-document-from-doc-viewer-dto.model';
import { RemoveCandidateDocumentRequest } from './models/remove-candidate-document-request.model';
import { UploaderDto } from './models/uploader-dto.model';
import { WasteDocumentRequestDto } from './models/waste-document-request-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class DocumentUploadToolClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createCandidateDocumentNote(candidateDocumentId: number, note: string): Observable<CandidateDocumentNoteDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/notes";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCandidateDocumentNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCandidateDocumentNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumentNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumentNoteDto>;
        }));
    }

    protected processCreateCandidateDocumentNote(response: HttpResponseBase): Observable<CandidateDocumentNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDocumentNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listCandidateDocumentNotes(candidateDocumentId: number): Observable<CandidateDocumentNoteDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/notes";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListCandidateDocumentNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListCandidateDocumentNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumentNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumentNoteDto[]>;
        }));
    }

    protected processListCandidateDocumentNotes(response: HttpResponseBase): Observable<CandidateDocumentNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDocumentNoteDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createNoteForCandidateDocuments(dto: NoteForCandidateDocumentDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNoteForCandidateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNoteForCandidateDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNoteForCandidateDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listGroupedPostedDocuments(filter_CandidateName: string | null | undefined, filter_ComplianceLiaison: string | null | undefined, filter_AssignedTo: string | null | undefined, filter_PostedBy: string | null | undefined, filter_StatusCode: LookupPendingUploadStatus | undefined, filter_LocumsOnly: boolean | null | undefined, filter_IsAccessControlOnly: boolean | null | undefined, filter_CandidateTypes: CandidateTypeValues[] | null | undefined, filter_IsCandidateUpload: boolean | undefined, filter_IsVendorUpload: boolean | undefined, filter_ActiveOnly: boolean | undefined, filter_InactiveOnly: boolean | undefined, filter_MasterFileOnly: boolean | undefined, filter_ContractStageCodes: string[] | null | undefined, filter_LOBIds: LineOfBusinessEnum[] | null | undefined, filter_FacilityIds: number[] | null | undefined, filter_AssociationIds: number[] | null | undefined, filter_HospitalSystemIds: number[] | null | undefined, filter_StartDateFrom: Date | null | undefined, filter_StartDateTo: Date | null | undefined, filter_DocDueDateFrom: Date | null | undefined, filter_DocDueDateTo: Date | null | undefined, filter_IsSearchView: boolean | undefined, filter_IsLargeDocsOnly: boolean | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfPostedDocGroupDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/grouped-candidate-documents?";
        if (filter_CandidateName !== undefined && filter_CandidateName !== null)
            url_ += "Filter.CandidateName=" + encodeURIComponent("" + filter_CandidateName) + "&";
        if (filter_ComplianceLiaison !== undefined && filter_ComplianceLiaison !== null)
            url_ += "Filter.ComplianceLiaison=" + encodeURIComponent("" + filter_ComplianceLiaison) + "&";
        if (filter_AssignedTo !== undefined && filter_AssignedTo !== null)
            url_ += "Filter.AssignedTo=" + encodeURIComponent("" + filter_AssignedTo) + "&";
        if (filter_PostedBy !== undefined && filter_PostedBy !== null)
            url_ += "Filter.PostedBy=" + encodeURIComponent("" + filter_PostedBy) + "&";
        if (filter_StatusCode === null)
            throw new Error("The parameter 'filter_StatusCode' cannot be null.");
        else if (filter_StatusCode !== undefined)
            url_ += "Filter.StatusCode=" + encodeURIComponent("" + filter_StatusCode) + "&";
        if (filter_LocumsOnly !== undefined && filter_LocumsOnly !== null)
            url_ += "Filter.LocumsOnly=" + encodeURIComponent("" + filter_LocumsOnly) + "&";
        if (filter_IsAccessControlOnly !== undefined && filter_IsAccessControlOnly !== null)
            url_ += "Filter.IsAccessControlOnly=" + encodeURIComponent("" + filter_IsAccessControlOnly) + "&";
        if (filter_CandidateTypes !== undefined && filter_CandidateTypes !== null)
            filter_CandidateTypes && filter_CandidateTypes.forEach(item => { url_ += "Filter.CandidateTypes=" + encodeURIComponent("" + item) + "&"; });
        if (filter_IsCandidateUpload === null)
            throw new Error("The parameter 'filter_IsCandidateUpload' cannot be null.");
        else if (filter_IsCandidateUpload !== undefined)
            url_ += "Filter.IsCandidateUpload=" + encodeURIComponent("" + filter_IsCandidateUpload) + "&";
        if (filter_IsVendorUpload === null)
            throw new Error("The parameter 'filter_IsVendorUpload' cannot be null.");
        else if (filter_IsVendorUpload !== undefined)
            url_ += "Filter.IsVendorUpload=" + encodeURIComponent("" + filter_IsVendorUpload) + "&";
        if (filter_ActiveOnly === null)
            throw new Error("The parameter 'filter_ActiveOnly' cannot be null.");
        else if (filter_ActiveOnly !== undefined)
            url_ += "Filter.ActiveOnly=" + encodeURIComponent("" + filter_ActiveOnly) + "&";
        if (filter_InactiveOnly === null)
            throw new Error("The parameter 'filter_InactiveOnly' cannot be null.");
        else if (filter_InactiveOnly !== undefined)
            url_ += "Filter.InactiveOnly=" + encodeURIComponent("" + filter_InactiveOnly) + "&";
        if (filter_MasterFileOnly === null)
            throw new Error("The parameter 'filter_MasterFileOnly' cannot be null.");
        else if (filter_MasterFileOnly !== undefined)
            url_ += "Filter.MasterFileOnly=" + encodeURIComponent("" + filter_MasterFileOnly) + "&";
        if (filter_ContractStageCodes !== undefined && filter_ContractStageCodes !== null)
            filter_ContractStageCodes && filter_ContractStageCodes.forEach(item => { url_ += "Filter.ContractStageCodes=" + encodeURIComponent("" + item) + "&"; });
        if (filter_LOBIds !== undefined && filter_LOBIds !== null)
            filter_LOBIds && filter_LOBIds.forEach(item => { url_ += "Filter.LOBIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_FacilityIds !== undefined && filter_FacilityIds !== null)
            filter_FacilityIds && filter_FacilityIds.forEach(item => { url_ += "Filter.FacilityIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AssociationIds !== undefined && filter_AssociationIds !== null)
            filter_AssociationIds && filter_AssociationIds.forEach(item => { url_ += "Filter.AssociationIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_HospitalSystemIds !== undefined && filter_HospitalSystemIds !== null)
            filter_HospitalSystemIds && filter_HospitalSystemIds.forEach(item => { url_ += "Filter.HospitalSystemIds=" + encodeURIComponent("" + item) + "&"; });
        if (filter_StartDateFrom !== undefined && filter_StartDateFrom !== null)
            url_ += "Filter.StartDateFrom=" + encodeURIComponent(filter_StartDateFrom ? "" + filter_StartDateFrom.toISOString() : "") + "&";
        if (filter_StartDateTo !== undefined && filter_StartDateTo !== null)
            url_ += "Filter.StartDateTo=" + encodeURIComponent(filter_StartDateTo ? "" + filter_StartDateTo.toISOString() : "") + "&";
        if (filter_DocDueDateFrom !== undefined && filter_DocDueDateFrom !== null)
            url_ += "Filter.DocDueDateFrom=" + encodeURIComponent(filter_DocDueDateFrom ? "" + filter_DocDueDateFrom.toISOString() : "") + "&";
        if (filter_DocDueDateTo !== undefined && filter_DocDueDateTo !== null)
            url_ += "Filter.DocDueDateTo=" + encodeURIComponent(filter_DocDueDateTo ? "" + filter_DocDueDateTo.toISOString() : "") + "&";
        if (filter_IsSearchView === null)
            throw new Error("The parameter 'filter_IsSearchView' cannot be null.");
        else if (filter_IsSearchView !== undefined)
            url_ += "Filter.IsSearchView=" + encodeURIComponent("" + filter_IsSearchView) + "&";
        if (filter_IsLargeDocsOnly !== undefined && filter_IsLargeDocsOnly !== null)
            url_ += "Filter.IsLargeDocsOnly=" + encodeURIComponent("" + filter_IsLargeDocsOnly) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGroupedPostedDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGroupedPostedDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfPostedDocGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfPostedDocGroupDto>;
        }));
    }

    protected processListGroupedPostedDocuments(response: HttpResponseBase): Observable<PagingTokenOfPostedDocGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfPostedDocGroupDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPostedDocPermissions(): Observable<PostedDocsPermissionDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/posted-doc-permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPostedDocPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPostedDocPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostedDocsPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostedDocsPermissionDto>;
        }));
    }

    protected processGetPostedDocPermissions(response: HttpResponseBase): Observable<PostedDocsPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PostedDocsPermissionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocument(candidateDocumentId: number): Observable<DocumentUploadToolDetailDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentUploadToolDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentUploadToolDetailDto>;
        }));
    }

    protected processGetCandidateDocument(response: HttpResponseBase): Observable<DocumentUploadToolDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentUploadToolDetailDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocumentInfo(candidateDocumentId: number): Observable<CandidateDocumentInfoResponse> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/info";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumentInfoResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumentInfoResponse>;
        }));
    }

    protected processGetCandidateDocumentInfo(response: HttpResponseBase): Observable<CandidateDocumentInfoResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDocumentInfoResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listCandidates(searchArgs: string | null | undefined, pageSize: number | undefined, skip: number | undefined): Observable<PagingTokenOfSearchCandidateDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidates?";
        if (searchArgs !== undefined && searchArgs !== null)
            url_ += "searchArgs=" + encodeURIComponent("" + searchArgs) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfSearchCandidateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfSearchCandidateDto>;
        }));
    }

    protected processListCandidates(response: HttpResponseBase): Observable<PagingTokenOfSearchCandidateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfSearchCandidateDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listContractHistoryForCandidate(candidateId: number): Observable<ContractHistoryDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidates/{candidateId}/contracts";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListContractHistoryForCandidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListContractHistoryForCandidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractHistoryDto[]>;
        }));
    }

    protected processListContractHistoryForCandidate(response: HttpResponseBase): Observable<ContractHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractHistoryDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUploaders(lineOfBusiness: LineOfBusinessEnum | undefined): Observable<UploaderDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/uploaders?";
        if (lineOfBusiness === null)
            throw new Error("The parameter 'lineOfBusiness' cannot be null.");
        else if (lineOfBusiness !== undefined)
            url_ += "lineOfBusiness=" + encodeURIComponent("" + lineOfBusiness) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploaders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploaders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploaderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploaderDto[]>;
        }));
    }

    protected processGetUploaders(response: HttpResponseBase): Observable<UploaderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploaderDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeCandidateDocument(request: RemoveCandidateDocumentRequest): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveCandidateDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCandidateDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveCandidateDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkUpdateCandidateDocuments(request: CandidateDocumentUpdateRequest): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateCandidateDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateCandidateDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateCandidateDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCandidateDocumentNote(candidateDocumentId: number, candidateDocumentNoteId: number, note: string): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/notes/{candidateDocumentNoteId}";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        if (candidateDocumentNoteId === undefined || candidateDocumentNoteId === null)
            throw new Error("The parameter 'candidateDocumentNoteId' must be defined.");
        url_ = url_.replace("{candidateDocumentNoteId}", encodeURIComponent("" + candidateDocumentNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCandidateDocumentNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCandidateDocumentNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCandidateDocumentNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    candidateLiaisonByContractId(contractId: number): Observable<PersonNameDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-liaison/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCandidateLiaisonByContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCandidateLiaisonByContractId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonNameDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonNameDto>;
        }));
    }

    protected processCandidateLiaisonByContractId(response: HttpResponseBase): Observable<PersonNameDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonNameDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignDocumentToContract(candidateDocumentId: number, request: AssignDocumentToContractRequest): Observable<AssignDocumentToContractResponseDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/assign";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignDocumentToContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignDocumentToContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignDocumentToContractResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignDocumentToContractResponseDto>;
        }));
    }

    protected processAssignDocumentToContract(response: HttpResponseBase): Observable<AssignDocumentToContractResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignDocumentToContractResponseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    assignAndFillSignedContract(request: FillPostionSignedContractDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/fillSigned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignAndFillSignedContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignAndFillSignedContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignAndFillSignedContract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    restoreFileBackup(candidateDocumentId: number): Observable<FileBackupStatuses> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/documents/backups";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreFileBackup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreFileBackup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileBackupStatuses>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileBackupStatuses>;
        }));
    }

    protected processRestoreFileBackup(response: HttpResponseBase): Observable<FileBackupStatuses> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileBackupStatuses;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rejectDocumentFromDocViewer(candidateDocumentId: number, request: RejectDocumentFromDocViewerDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/reject-document";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectDocumentFromDocViewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectDocumentFromDocViewer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRejectDocumentFromDocViewer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocumentIds(candidateId: number, assignedUploaderId: number | null | undefined, isSignedContract: boolean | undefined, isCandidateUpload: boolean | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidates/{candidateId}/candidate-document-ids?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        if (assignedUploaderId !== undefined && assignedUploaderId !== null)
            url_ += "assignedUploaderId=" + encodeURIComponent("" + assignedUploaderId) + "&";
        if (isSignedContract === null)
            throw new Error("The parameter 'isSignedContract' cannot be null.");
        else if (isSignedContract !== undefined)
            url_ += "isSignedContract=" + encodeURIComponent("" + isSignedContract) + "&";
        if (isCandidateUpload === null)
            throw new Error("The parameter 'isCandidateUpload' cannot be null.");
        else if (isCandidateUpload !== undefined)
            url_ += "isCandidateUpload=" + encodeURIComponent("" + isCandidateUpload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumentIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumentIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetCandidateDocumentIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocumentDetail(candidateDocumentId: number): Observable<CandidateDocumentViewerDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/detail";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumentDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumentDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CandidateDocumentViewerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CandidateDocumentViewerDto>;
        }));
    }

    protected processGetCandidateDocumentDetail(response: HttpResponseBase): Observable<CandidateDocumentViewerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CandidateDocumentViewerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocumentsFromGroup(candidateId: number, assignedUploaderId: number | null | undefined, isSignedContract: boolean | undefined, isCandidateUpload: boolean | undefined, isComplete: boolean | undefined): Observable<ComplianceDocumentUploadDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidates/{candidateId}/candidate-documents?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        if (assignedUploaderId !== undefined && assignedUploaderId !== null)
            url_ += "assignedUploaderId=" + encodeURIComponent("" + assignedUploaderId) + "&";
        if (isSignedContract === null)
            throw new Error("The parameter 'isSignedContract' cannot be null.");
        else if (isSignedContract !== undefined)
            url_ += "isSignedContract=" + encodeURIComponent("" + isSignedContract) + "&";
        if (isCandidateUpload === null)
            throw new Error("The parameter 'isCandidateUpload' cannot be null.");
        else if (isCandidateUpload !== undefined)
            url_ += "isCandidateUpload=" + encodeURIComponent("" + isCandidateUpload) + "&";
        if (isComplete === null)
            throw new Error("The parameter 'isComplete' cannot be null.");
        else if (isComplete !== undefined)
            url_ += "isComplete=" + encodeURIComponent("" + isComplete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumentsFromGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumentsFromGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceDocumentUploadDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceDocumentUploadDto[]>;
        }));
    }

    protected processGetCandidateDocumentsFromGroup(response: HttpResponseBase): Observable<ComplianceDocumentUploadDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceDocumentUploadDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateDocumentDetails(candidateId: number, assignedUploaderId: number | null | undefined, isSignedContract: boolean | undefined, isCandidateUpload: boolean | undefined): Observable<ComplianceCandidateDocumentDetailDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidates/{candidateId}/candidate-document-details?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        if (assignedUploaderId !== undefined && assignedUploaderId !== null)
            url_ += "assignedUploaderId=" + encodeURIComponent("" + assignedUploaderId) + "&";
        if (isSignedContract === null)
            throw new Error("The parameter 'isSignedContract' cannot be null.");
        else if (isSignedContract !== undefined)
            url_ += "isSignedContract=" + encodeURIComponent("" + isSignedContract) + "&";
        if (isCandidateUpload === null)
            throw new Error("The parameter 'isCandidateUpload' cannot be null.");
        else if (isCandidateUpload !== undefined)
            url_ += "isCandidateUpload=" + encodeURIComponent("" + isCandidateUpload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateDocumentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateDocumentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceCandidateDocumentDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceCandidateDocumentDetailDto[]>;
        }));
    }

    protected processGetCandidateDocumentDetails(response: HttpResponseBase): Observable<ComplianceCandidateDocumentDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceCandidateDocumentDetailDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCandidateNotes(candidateId: number, assignedUploaderId: number | null | undefined, isSignedContract: boolean | undefined, isCandidateUpload: boolean | undefined): Observable<ComplianceCandidateDocumentNoteDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidates/{candidateId}/notes?";
        if (candidateId === undefined || candidateId === null)
            throw new Error("The parameter 'candidateId' must be defined.");
        url_ = url_.replace("{candidateId}", encodeURIComponent("" + candidateId));
        if (assignedUploaderId !== undefined && assignedUploaderId !== null)
            url_ += "assignedUploaderId=" + encodeURIComponent("" + assignedUploaderId) + "&";
        if (isSignedContract === null)
            throw new Error("The parameter 'isSignedContract' cannot be null.");
        else if (isSignedContract !== undefined)
            url_ += "isSignedContract=" + encodeURIComponent("" + isSignedContract) + "&";
        if (isCandidateUpload === null)
            throw new Error("The parameter 'isCandidateUpload' cannot be null.");
        else if (isCandidateUpload !== undefined)
            url_ += "isCandidateUpload=" + encodeURIComponent("" + isCandidateUpload) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCandidateNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCandidateNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceCandidateDocumentNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceCandidateDocumentNoteDto[]>;
        }));
    }

    protected processGetCandidateNotes(response: HttpResponseBase): Observable<ComplianceCandidateDocumentNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceCandidateDocumentNoteDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    moveDocumentToWaste(candidateDocumentId: number, request: WasteDocumentRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/candidate-documents/{candidateDocumentId}/move-to-waste";
        if (candidateDocumentId === undefined || candidateDocumentId === null)
            throw new Error("The parameter 'candidateDocumentId' must be defined.");
        url_ = url_.replace("{candidateDocumentId}", encodeURIComponent("" + candidateDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveDocumentToWaste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveDocumentToWaste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveDocumentToWaste(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listFaciltyRequirements(facilityId: number): Observable<FacilityRequirementDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/document-upload-tool/facility-requirements/{facilityId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListFaciltyRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListFaciltyRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityRequirementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityRequirementDto[]>;
        }));
    }

    protected processListFaciltyRequirements(response: HttpResponseBase): Observable<FacilityRequirementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FacilityRequirementDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}